module.exports = __webpack_public_path__ + "src/assets/sounds/sand_main_sound.mp3";